import noAuthApiClient from '../http/noAuthApiClient';
import { setAcademyContentPageName } from '../store/app/action-creators';
import { kebabToSpacedCamel } from '../utils/data-structure-utils/kebabToCamel';
import { getLessonId, getTrackId } from './academyFormSubmissionUtils';
export const getCoursePageName = path => `Course: ${kebabToSpacedCamel(path)}`;
export const getLessonPageName = path => `Lesson: ${kebabToSpacedCamel(path)}`;

const fetchLessonContentName = id => {
  return noAuthApiClient.get(`/acquisition/v1/academy-content/lesson?id=${id}`);
};

const fetchTrackContentName = id => {
  return noAuthApiClient.get(`/acquisition/v1/academy-content/track?id=${id}`);
};

export const getAcademyContentPageName = () => {
  const lessonId = getLessonId();
  const trackId = getTrackId();

  if (lessonId) {
    return fetchLessonContentName(lessonId);
  }

  if (trackId) {
    return fetchTrackContentName(trackId);
  } else {
    return Promise.resolve(null);
  }
};
export const handleAcademyPageNameSuccess = ({
  name
}, dispatch) => {
  const lessonId = getLessonId();
  const trackId = getTrackId();
  let pageName;

  if (lessonId) {
    pageName = getLessonPageName(name);
  }

  if (trackId) {
    pageName = getCoursePageName(name);
  }

  if (pageName) {
    dispatch(setAcademyContentPageName(pageName));
  }
};